export function copyrights(){
    const d = new Date();
    const current_year = d.getFullYear();
    // Copyrights の 発行年を現在の年に書き換え
    let base_str = `Copyright &copy; ${current_year} FUJIKIGUMI Co., Ltd. All rights reserved.`;
    $(".footer .copyrights p").html(base_str);
}